import { useState } from 'react';
import useBillingStore from '../../stores/useBillingStore';

/**
 * Shared state + submit flow for the enable / edit-limit / disable overage modals
 * (used by OverageSettingsCard and CreditsExhaustedDialog).
 */
export default function useOverageModals({ onSuccess } = {}) {
  const updateOverageSettings = useBillingStore((s) => s.updateOverageSettings);

  const [enableOpen, setEnableOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [disableOpen, setDisableOpen] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState('');

  const openEnable = () => {
    setActionError('');
    setEnableOpen(true);
  };
  const openEdit = () => {
    setActionError('');
    setEditOpen(true);
  };
  const openDisable = () => {
    setActionError('');
    setDisableOpen(true);
  };

  const runUpdate = async (body) => {
    setActionLoading(true);
    setActionError('');
    try {
      await updateOverageSettings(body);
      setEnableOpen(false);
      setEditOpen(false);
      setDisableOpen(false);
      onSuccess?.();
    } catch (e) {
      setActionError(e?.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setActionLoading(false);
    }
  };

  return {
    enableOpen,
    editOpen,
    disableOpen,
    setEnableOpen,
    setEditOpen,
    setDisableOpen,
    openEnable,
    openEdit,
    openDisable,
    actionLoading,
    actionError,
    runUpdate,
  };
}
